import * as React from "react";
import Component from "../../AbstractComponent";

import { PromptDialog } from "./PromptDialog";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import Searchbar from "../Searchbar/Searchbar";
import Constants from "../../../Action/Constants";
import { Company } from "../../../Entity/Entities/Company/Company";
import TextField from "../Material/TextField";
import Formatter from "../../../Localization/Formatter";
import { PageTransition } from "../Spinner/PageTransition";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableComponent } from "../Table/TableComponent";
import Checkbox from '@material-ui/core/Checkbox';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import Time from "../../../Time/Time";

export class CoachCreateCreditInvoice extends Component {
  protected timer;

  public state = {
    isOpen: false,
    step: this.props.step ? this.props.step : 1,
    createCreditProcessAmount: "",
    createCreditProcessDescription: (this.props.charge?.invoiceNumber && this.props.charge?.description) ? `${this.trans("page/chargeupdate-preprocess/credit")}: ${this.props.charge?.invoiceNumber} ${this.props.charge?.description}` : this.trans("page/chargeupdate-preprocess/credit-defaultdescription"),
    isSaving: false,
    selectedEntityForExistingCharge: null,
    objectCharges: [],
    selectedObjectChargesRows: [],
    chargeIds: [],
    showAllFields: false,
    invoiceDateForCharge: null,
    invoiceNumberForCharge: "",
    isSaveButtonClicked: false,
    charge: null
  };

  constructor(public props) {
    super(props);
  }

  public getDescription() {
    let description;
    if (this.props.charge?.invoiceNumber && this.props.charge?.description) {
      description = `${this.trans("page/chargeupdate-preprocess/credit")}: ${this.props.charge?.invoiceNumber} ${this.props.charge?.description}`
    } else if (this.props.charge?.invoiceNumber) {
      description = `${this.trans("page/chargeupdate-preprocess/credit")}: ${this.props.charge?.invoiceNumber}`
    } else if (this.props.charge?.description) {
      description = `${this.trans("page/chargeupdate-preprocess/credit")}: ${this.props.charge?.description}`
    } else {
      description = this.trans("page/chargeupdate-preprocess/credit-defaultdescription")
    }
    return description
  }
  public componentWillMount() {

    this.setState({
      createCreditProcessAmount: this.props.charge?.isFullyPaid() ? Formatter.simpleFormatNumber(this.props.charge?.amount) : Formatter.simpleFormatNumber(this.props.charge?.amountRemaining),
      // invoiceDateForCharge: this.props?.charge?.invoiceDate,
      // invoiceNumberForCharge:  this.props?.charge?.invoiceNumber,
      createCreditProcessDescription: this.getDescription(),
      isOpen: this.props.isOpen,
      step: this.props.step ? this.props.step : this.state.step,
      charge: this.props.charge
    });
  }

  public createCredit = (): void => {
    const charge = this.props.charge ? this.props.charge : this.state.charge;

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_START,
        payload: {
          charge: charge,
          amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.createCreditProcessAmount)).replace(",", ".")).toFixed(2)),
          description: this.state.createCreditProcessDescription,
          invoiceDate: Time.formatOrNull(this.state.invoiceDateForCharge),
          invoiceNumber: this.state.invoiceNumberForCharge,
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });
          this.setState({
            isSaving: false
          });

          this.onCloseCreateCreditInvoiceCoach();

          if (typeof this.props.initializePage === "function") {
            return this.props.initializePage.call(this, this.props.charge?.id)
          }

          this.redirect(`/app/charge/update/${charge?.id}`);

        },
        onError: () => {
          this.setState({
            isSaving: false,
            anchorEl: null
          });
        }
      });
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }


  public onCloseCreateCreditInvoiceCoach = () => {
    setTimeout(() => { this.clearState() }, 100);
    this.clearBackEndErrors();

    if (this.props.onCloseCreateCreditInvoiceCoach) {
      this.props.onCloseCreateCreditInvoiceCoach.call(this);
    }
  }

  public clearState = () => {
    this.setState({
      isOpen: false,
      step: 1,
      createCreditProcessAmount: "",
      createCreditProcessDescription: this.getDescription(),
      charge: null,
      isSaving: false,
      selectedEntityForExistingCharge: null,
      objectCharges: [],
      selectedObjectChargesRows: [],
      chargeIds: [],
      showAllFields: false,
      invoiceDateForCharge: null,
      invoiceNumberForCharge: "",
      isSaveButtonClicked: false
    })
  }

  public selectEntityForExistingCharge = (entity: PropertyInterface | UnitInterface | ContractInterface): void => {
    this.setState({
      selectedEntityForExistingCharge: entity,
      selectedDirectIndirectChargesRows: [],
      selectedObjectChargesRows: [],
      chargeIds: []
    }, () => {
      // after selecting an object should fetch charges related to this object
      this.fetchExistingCharges();
    });
  }

  // should fetch charges for list related to contact/company or to some object
  public fetchExistingCharges = (): void => {
    const mainPayload: any = {
      //chargeClassId: ChargeClassContainer.pickIdFromLabel("Receivable"),
      isAfterStartDate: 1, // do not fetch charges before start date
    };

    // mainPayload.paid = 0

    // fetch charges for selected object
    if (!!this.state.selectedEntityForExistingCharge) {
      const payload = { ...mainPayload };

      if (this.state.selectedEntityForExistingCharge instanceof Property) {
        payload.propertyId = this.state.selectedEntityForExistingCharge.id;
      }

      if (this.state.selectedEntityForExistingCharge instanceof Unit) {
        payload.unitId = this.state.selectedEntityForExistingCharge.id;
      }

      if (this.state.selectedEntityForExistingCharge instanceof Contract) {
        payload.contractId = this.state.selectedEntityForExistingCharge.id;
      }

      if (this.state.selectedEntityForExistingCharge instanceof Company) {
        payload.ownerId = this.state.selectedEntityForExistingCharge.id;
      }

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
        payload: { ...payload },
        onSuccess: (data) => {
          const filteredCharges = data.charges.filter(charge => charge.type.id !== TypeContainer.pickIdFromLabel("Settlement"));

          this.setState({
            objectCharges: filteredCharges
          })
        }
      })
    }
  }

  public clearEntityForExistingCharge = (): void => {
    this.setState({
      selectedEntityForExistingCharge: null,
      selectedDirectIndirectChargesRows: [],
      selectedObjectChargesRows: [],
      chargeIds: [],
      objectCharges: []
    });
  }

  public onObjectChargeRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const chargeId: number = this.state.objectCharges[row].id;


    this.selectUnselectObjectCharge(row, chargeId);

  }

  public selectUnselectObjectCharge = (row: number, chargeId: number) => {
    if (this.state.selectedObjectChargesRows.includes(row)) {
      const selectedObjectChargesRows = this.state.selectedObjectChargesRows.filter(rowId => rowId !== row);
      const chargeIds = this.state.chargeIds.filter(id => id !== chargeId);

      this.setState({
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: selectedObjectChargesRows,
        chargeIds: chargeIds
      });
    } else {
      this.setState({
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [row],
        chargeIds: [chargeId]
      }, () => {
        if (this.state.chargeIds.length > 0) {
          const charge = this.state.objectCharges.find(elem => elem?.id === this.state.chargeIds[0])
          this.setState({
            hasModifiedData: true,
            charge: charge,
            createCreditProcessAmount: Formatter.simpleFormatNumber(charge.amountRemaining),
            invoiceDateForCharge: charge?.invoiceDate,
            invoiceNumberForCharge: charge?.invoiceNumber
          });
        }
      });
    }
  }

  public getCharges = (charges: ChargeInterface[], selectedChargesRows: number[], callback: any): any => {
    return charges
      .map((charge: ChargeInterface, index: number) => {
        if (!charge) {
          return;
        }

        const shouldShowPaidDate = !!charge.oldestPaymentDate;
        const isItemSelected = selectedChargesRows.includes(index);
        const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <TableRow
            hover
            key={`charge-${charge.id}`}
            // onClick={() => {
            //   this.redirect(`/app/charge/update/${charge.id}`);
            // }}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell
              padding="checkbox"
              onClick={event => { event.preventDefault(); event.stopPropagation(); callback(event, [index]) }}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell>
            <TableCell style={{ width: "24px", paddingLeft: "10px", paddingRight: "5px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px" }}>
                <div
                  style={{ color: charge.getIconColor() }}
                  className="icon icon-ic-charge"
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{ width: "100px", maxWidth: "100px" }}>
              {
                shouldShowPaidDate && (
                  <div style={{ display: "inline-flex", flexDirection: "column" }}>
                    <span>{this.formatter.formatDate(charge.invoiceDate)}</span>
                    <span style={{ fontSize: "12px", color: "gray" }}>{`${this.trans("status-paid").toLowerCase()}: ${this.formatter.formatDate(charge.oldestPaymentDate)}`}</span>
                  </div>
                )
              }
              {
                !shouldShowPaidDate && (
                  <span>{this.formatter.formatDate(charge.invoiceDate)}</span>
                )
              }
            </TableCell>
            <TableCell>
              <div style={{ display: "inline-flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "flex-start" }}>
                  {charge?.name || ""}
                  {charge.creationTypeDisplayName && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2px 0px 0px 5px"
                      }}
                    >
                      <div className="list-label creation-type-label">
                        {charge.creationTypeDisplayName}
                      </div>
                    </div>
                  )}
                </div>
                <span style={{ fontSize: "12px", color: "gray" }}>
                  {`${charge && charge.description === "" ? Formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system) + "," + Formatter.monthFullFormatDate(charge.firstDate) : charge.description} ${!!charge.relatedEntity ? "- " + charge.relatedEntity.displayName : ""}`}
                </span>
              </div>
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "28%" }}>
              {
                <div style={{ display: "inline-flex", flexDirection: "column" }}>
                  <span>{charge.chargeClass.id == ChargeClassContainer.pickIdFromLabel("Payable") && charge?.amount > 0 && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(charge.amount, charge.currency)}</span>
                  {this.renderChargeAmountHint(charge)}
                </div>
              }
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
			return
		}

    if((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isPayable){
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-pay")}`
    } else if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isReceivable) {
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-receive")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isPayable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-pay")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isReceivable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-receive")}`
    } else if (charge.isFullyPaid() && charge?.isReceivable) {
      status = `${this.trans("status-received")}`
    } else if (charge.isFullyPaid() && charge?.isPayable) {
      status = `${this.trans("status-amount/paid")}`
    } else {
      status = ""
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {status}
      </span>
    );
  }

  public changeView = () => {
    this.setState({
      showAllFields: !this.state.showAllFields,
    });
  }

  public selectDate = (date: Date, identifier: string): void => {
    if (!date && (identifier === "firstDateOfStatementPeriodForPayment" || identifier === "dateOfThePayment" || identifier === "paymentDateQuickOption")) {
      return;
    }

    this.setState({
      [identifier]: date, // todo fix hardcoded value
    });
  }

  public changeInvoiceNumberForCharge = (event): void => {
    const invoiceNumber: string = event.target.value;

    this.setState({
      invoiceNumberForCharge: invoiceNumber
    });
  }

  public renderContent = () => {
    if (this.state.step === 1) {
      return (
        <div className="search-bar-container" style={{ margin: "10px 0 -10px 0" }}>
          <div>
            {this.trans("coach/creditcharge-info1")}
          </div>
          <Searchbar
            {...this.props}
            id="selectedEntityForExistingCharge"
            className="scroll-to-selectedEntityForExistingCharge"
            height={400}
            floatingLabelText={this.trans("coach/credit-label/object")}
            allResults={true}
            objectField={true}
            onChange={this.selectEntityForExistingCharge}
            onClear={this.clearEntityForExistingCharge}
            selectedEntity={this.state.selectedEntityForExistingCharge}
            searchParameter={"objectForChargeSearch"}
            error={this.getErrorFor("selectedEntityForExistingCharge")}
            scrollToEndOfPage={false}
            searchText={this.state.selectedEntityForExistingCharge ? `${this.state.selectedEntityForExistingCharge.nameOfEntity}, ${this.state.selectedEntityForExistingCharge.displayName}` : null}
            styleInModal={"pick-object-modal"}
          />

          <TableComponent
            {...this.props}
            paginator={{
              name: "ExsistingObjectChargesList",
              path: this.props.app.paginator
            }}
            dispatch={this.props.dispatch}
            className="listing-table new-payment-charges-table"
            rows={this.getCharges(this.state.objectCharges, this.state.selectedObjectChargesRows, this.onObjectChargeRowSelection)}
          />
          {
            this.state.selectedEntityForExistingCharge && this.getCharges(this.state.objectCharges, this.state.selectedObjectChargesRows, this.onObjectChargeRowSelection)?.length === 0 &&
            <span style={{ color: "gray", paddingLeft: "13px" }}>{this.trans("coach/creditcharge-error")}</span>
          }
        </div>
      );
    } else {
      return (
        <div>
          <div>{this.trans("page/chargeupdate-preprocess/credit-info")}</div>
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-amount"
            type="text"
            label={this.trans("label-amount")}
            value={this.state.createCreditProcessAmount}
            onChange={e => this.setState({ createCreditProcessAmount: e.target.value })}
            autoFocus={true}
            variant="standard"
            error={!!this.getErrorFor("amount")}
          />
          {!!this.getErrorFor("amount") && <div className="component-error-text">{this.getErrorFor("amount")}</div>}

          <div className="hint-styles-wrapper">
            <span className="hint-styles">{this.trans("dialog/coachcreditinvoice-vat/info")}</span>
          </div>

          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-description"
            type="text"
            multiline
            rowsMax="25"
            rows="3"
            label={this.trans("description")}
            value={this.state.createCreditProcessDescription}
            onChange={e => this.setState({ createCreditProcessDescription: e.target.value })}
            variant="standard"
            error={!!this.getErrorFor("description")}
          />
          {!!this.getErrorFor("description") && <div className="component-error-text">{this.getErrorFor("description")}</div>}

          {
          this.state?.charge?.isPayable &&
            <div 
					  style={{
					  	width: "40px",
					  	display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }} 
            onClick={this.changeView}
				  >
					  {
						  this.state.showAllFields ? 
                <ExpandLess style={{marginTop: "-7px"}} /> :
                <ExpandMore style={{marginTop: "-7px"}} />
					  }
            <div>{this.trans("label-more")}</div>
				  </div>
          }

              {
                this.state.showAllFields &&
                <React.Fragment>
                  <DatePickerComponent
                    {...this.props}
                    className={"full-size invoice-block scroll-to-invoiceDateForCharge"}
                    label={this.trans("section/charge-field/invoicedate-label")}
                    initialDate={this.state.invoiceDateForCharge}
                    onChange={date => this.selectDate(date, "invoiceDateForCharge")}
                    clearButton={true}
                    error={this.getErrorFor("invoiceDateForCharge")}
                  />
                  <TextField
                    autoComplete="off"
                    //id="invoiceNumberForCharge"
                    className="full-size form-element scroll-to-invoiceNumberForCharge"
                    type="text"
                    label={this.trans("section/charge-field/invoicenumber-label")}
                    value={this.state.invoiceNumberForCharge}
                    onChange={this.changeInvoiceNumberForCharge}
                    variant="standard"
                    error={!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")}
                  />
                  {(!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")) && <div className="component-error-text">{this.getErrorFor("invoiceNumberForCharge") || this.getErrorFor("invoiceNumber")}</div>}
                </React.Fragment>
              }
            </div>
      );
    }
  }

  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          innerDialogClasses="create-credit-invoice coach-scrollable-presentation dialog-scrollable"
          scrollablePresentation={true}
          openLeavePrompt={this.state.isOpen}
          title={this.trans("page/chargeupdate-preprocess/credit-title")}
          content={this.renderContent()}
          positiveButtonLabel={this.state.step === 1 ? this.trans("button-next") : this.trans("button-create")}
          disablePositiveButton={this.state?.chargeIds?.length === 0 && this.state.step === 1}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => {
            this.setState({
              isSaveButtonClicked: true
            }, () => {
              if (this.state.step === 2 && (this.state?.chargeIds?.length > 0 || this.props.charge)) {
                this.createCredit();
              } else {
                this.setState({
                  step: 2,
                  createCreditProcessAmount: this.formatter.formatNumber(this.state.charge.amount)
                });
              }
            })
          }}
          onDiscard={() => this.onCloseCreateCreditInvoiceCoach()}
        />
        <PageTransition isSaving={this.state.isSaving}
        />
      </div>
    );
  }
}
